import { SizeClassComparer } from "./SizeClassComparer";
import { useMemo } from "react";
import { usePaneWidth } from "./usePaneWidth";

export const usePaneWidthComparer = (): SizeClassComparer => {
  const width = usePaneWidth();
  return useMemo(() => new SizeClassComparer(width), [width]);
};
